import {Typography} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import CorteOperacaoView from "./CorteOperacaoView";
import {getOrdensParaCorte} from "../../../actions/orderActions";
import { useDispatch, useSelector} from "react-redux";
import {getItemCodigoBarras} from "../../../actions/tireActions";
import ZebraBrowserPrint from "./ZebraBrowserPrint";

const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,


    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));


const CorteOperacao = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const ordensParaCorte = useSelector(state =>   state.ordemServicoReducer.ordensParaCorte);
    //const itemCodigoBrras = useSelector(state =>   state.tires.itemCodigoBarras);

     const [openCorte, setOpenCorte] = useState(false);
     const [ contador, setContador] = useState(1);
    const [os, setOS] = useState({});

    useEffect( () => {
        console.log("useEffect inicial []");
        dispatch(getOrdensParaCorte());
        dispatch(getItemCodigoBarras());
    }, []);

    useEffect(()=>{
        if (!openCorte) {
            dispatch(getOrdensParaCorte());
        }
    },[openCorte]);

    useEffect(()=>{
        console.log("useEffect start");
        let tempoRefresh = 30;
        const interval=setInterval(()=>{
            if (!openCorte) {
                dispatch(getOrdensParaCorte());
            }
            setContador(contador +1);
        },tempoRefresh * 1000);
        return()=>clearInterval(interval)
    },[contador]);


    const cbSetOpenCorte = (os, b) => {

         setOS(os);
         setOpenCorte(b);
     }

    return (
        <React.Fragment>
            <Grid item  xs={12} sm={12} lg={12} xl={12}>


                <Grid item  xs={12} sm={12} lg={12} xl={12}>
                    <CorteOperacaoView ordemServicos={ordensParaCorte} osCortando={os} openCorte={openCorte} cbOpenCorte={cbSetOpenCorte} />
                </Grid>
            </Grid>

        </React.Fragment>
    )

}

 export default CorteOperacao;
